<template>
    <app-stepper-section label="Endereço">
        <v-flex xs12 text-xs-center>
            <v-autocomplete ref="input"
                            v-model="timezone"
                            :items="listTimezones"
                            :search-input.sync="searchTimezones"
                            item-text="label"
                            no-data-text="Nenhum registro encontrado"
                            item-value="id"
                            label="Timezone"
                            prepend-inner-icon="mdi-magnify"></v-autocomplete>
        </v-flex>
        <v-flex xs12 text-xs-center>
            <v-flex xs5>
                <v-text-field label="Cep" v-on:blur="findAddress()" v-model="zipCode" mask="#####-###"></v-text-field>
            </v-flex>
            <v-flex xs5>
                <v-text-field label="Rua" v-model="streetName"></v-text-field>
            </v-flex>
        </v-flex>
        <v-flex xs12 text-xs-center>
            <v-flex xs5>
                <v-text-field label="Número" v-model="streetNumber"></v-text-field>
            </v-flex>
            <v-flex xs5>
                <v-text-field label="Bairro" v-model="neighborhood"></v-text-field>
            </v-flex>
        </v-flex>
        <v-flex xs12 text-xs-center>
            <v-flex xs5>
                <v-text-field label="Cidade" v-model="city"></v-text-field>
            </v-flex>
            <v-flex xs5>
                <v-text-field label="UF" v-model="state"></v-text-field>
            </v-flex>
        </v-flex>
    </app-stepper-section>
</template>

<script>
    import AppStepperSection from '@components/StepperSection'
    import _ from 'lodash'

    export default {
        data() {
            return {
                listTimezonesFull:[],
                listTimezones:[]
            }
        },

        components: {
            AppStepperSection,
        },

        props: {
            value: {
                type: Object
            }
        },

        watch: {
            filtersTimezones() {
                this.loadTimezones()
            }
        },

        computed: {
            timezone: {
                get() {
                    return this.value.timezone
                },
                set(timezone) {
                    this.value.timezone = timezone
                },
            },
            zipCode: {
                get() {
                    return this.value.zipCode
                },
                set(zipCode) {
                    this.$emit('input', {...this.value, zipCode})
                },
            },
            streetName: {
                get() {
                    return this.value.streetName
                },
                set(streetName) {
                    this.$emit('input', {...this.value, streetName})
                },
            },
            streetNumber: {
                get() {
                    return this.value.streetNumber
                },
                set(streetNumber) {
                    this.$emit('input', {...this.value, streetNumber})
                },
            },
            neighborhood: {
                get() {
                    return this.value.neighborhood
                },
                set(neighborhood) {
                    this.$emit('input', {...this.value, neighborhood})
                },
            },
            city: {
                get() {
                    return this.value.city
                },
                set(city) {
                    this.$emit('input', {...this.value, city})
                },
            },
            state: {
                get() {
                    return this.value.state
                },
                set(state) {
                    this.$emit('input', {...this.value, state})
                },
            },
        },

        methods: {
            async findAddress(){
                if (!this.zipCode || this.zipCode.replace('-', '').length < 8)
                    return

                const address = await this.$api.address.search(this.zipCode.replace('-', ''))
                this.value.streetName = address.streetName
                this.value.neighborhood = address.neighborhood
                this.value.city = address.city
                this.value.state = address.state
            },

            async loadTimezones() {
                let list = await this.$api.general.loadTimezones()
                this.listTimezonesFull = _.map(list,
                    (value, key) => {
                        return {
                            id: key,
                            label: value
                        }
                    }
                )
                this.listTimezones = this.listTimezonesFull;
            },
            searchTimezones(search) {
                this.listTimezones = _.filter(this.listTimezonesFull,
                    (timezone) => {
                        return timezone.label.includes(search)
                    }
                )
            },
            resetTimezones() {
                this.listTimezones = this.listTimezonesFull;
            },
        },

        mounted() {
            this.loadTimezones()
        }
    }
</script>

<style scoped>
    .flex {
        justify-content: space-between;
    }
</style>
